import { reactive } from 'vue'

export const appStore = reactive({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  isOnline: typeof navigator === 'undefined' ? true : navigator.onLine,
  offlineReady: false,
  pendingSyncCount: 0,
  syncError: null,
  importingInviteesEventId: null,
  toast: {
    open: false,
    message: '',
    type: 'success',
    timeout: 10000,
  },
  updateAvailable: false,
  updateServiceWorker: null,
})

export function initializeConnectivity () {
  if (typeof window === 'undefined') {
    return
  }

  window.addEventListener('online', () => {
    setOnlineStatus(true)
  })

  window.addEventListener('offline', () => {
    setOnlineStatus(false)
  })
}

export function setOnlineStatus (isOnline) {
  appStore.isOnline = isOnline
}

function showToast (message, type) {
  appStore.toast.message = message
  appStore.toast.type = type
  appStore.toast.open = true
}

export function showSuccessToast (message) {
  showToast(message, 'success')
}

export function showErrorToast (message) {
  showToast(message, 'error')
}

export function showRequestErrorToast (error, fallbackMessage) {
  showErrorToast(error?.status === 403
    ? 'Nemate potrebne ovlasti za ovu radnju.'
    : fallbackMessage)
}

export function closeToast () {
  appStore.toast.open = false
}
